import EventEmitter from './EventEmitter.js'
import Experience from '../Experience.js'
export default class Sizes extends EventEmitter
{
    constructor()
    {
        super()
        this.experience = new Experience()

        this.canvas = this.experience.canvas
        console.log(this.canvas);

        // Setup
        this.width = this.canvas.offsetWidth
        console.log(this.width);
        this.height = this.canvas.offsetHeight
        this.pixelRatio = Math.min(window.devicePixelRatio, 2)

        // Resize event
        window.addEventListener('resize', () =>
        {
            this.width = this.canvas.offsetWidth
            this.height = this.canvas.offsetHeight
            this.pixelRatio = Math.min(window.devicePixelRatio, 2)

            this.trigger('resize')
        })
    }
}